import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Months } from 'src/app/models/months';
import { HttpClient } from '@angular/common/http';
import { CoreService } from '../core/core.service';
import { Years } from 'src/app/models/years';
import { ReportCalculations } from 'src/app/models/reportCalculations';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  constructor(private coreService: CoreService, private http: HttpClient) { }
  _url: any
  getMonths(): Observable<Months[]> {
    return  this.http.get<Months[]>(this.coreService.appRoot + '/api/months');
  }

  getYears(): Observable<Years[]> {
    return  this.http.get<Years[]>(this.coreService.appRoot + '/api/years');
  }

  getReportsCalculations(month, year): Observable<ReportCalculations[]> {
    const data = { month: month, year: year };
    return  this.http.post<ReportCalculations[]>(this.coreService.appRoot + '/api/reportsCalculation', data);
  }

  getReportsCalculationsPdf(month, year, type): Observable<Blob> {
    const data = { month: month, year: year, type: type };
    return  this.http.post<Blob>( this.coreService.appRoot + '/api/reportsCalculationPdf' , data,
    { responseType: 'blob' as 'json'} );
  }
  getReportsCalculationsPdf2(): Observable<any> {
    return  this.http.get<any>(this.coreService.appRoot + '/api/reportsCalculationPdf');
  }
}
